'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var style = {
  root: {
    height: 'calc(100% - 112px)',
    position: 'relative'
  },
  list: {
    overflow: 'auto',
    width: '100%',
    height: 'auto',
    maxHeight: '100%',
    paddingTop: '16px',
    paddingLeft: '16px',
    paddingRight: '16px',
    paddingBottom: '0',
    position: 'absolute',
    bottom: '0',
    boxSizing: 'border-box',
    margin: '0'
  }
};

exports.default = style;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/anchor-ui/message-list/styles.js
// module id = 819
// module chunks = 0